<div class="wetter_content_container">

  <!-- TODO: Aus Karten Map Array machen -->
  <section class="bericht-text-container">
    <h3>{{wetterPdf !== undefined && wetterPdf?.karten !== undefined ? 'PDF Download (Stand:' + wetterPdf?.datum + ')' : 'Keine PDF verfügbar'}}</h3>
    <mat-list class="wetter_karte_list">
      <mat-list-item (click)="openLink(karte?.wetterKarte?.link)" class="wetter_karte_item"
                     *ngFor="let karte of wetterPdf?.karten;let i = index">
        <span class="wetter_karte_item_name">{{i + 1}}
          .{{karte?.wetterKarte?.name}}</span>
        <button matPrefix mat-icon-button class="wetter_karte_item_button">
          <mat-icon matListIcon>download_file</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </section>

</div>
